module.exports = __webpack_public_path__ + "static/media/call.d517b359.jpeg";